<template>
  <v-banner density="compact" :icon class="px-0">
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend" />
    </template>
    <slot />
  </v-banner>
</template>

<script setup lang="ts">
defineProps<{
  icon?: string;
}>();
</script>

<style scoped>
:deep(.v-banner__prepend) {
  margin-inline-end: var(--space-2);
  align-self: center;
}
</style>